// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module--content--3ffw0","label":"index-module--label--3nGuV","ukIcon":"index-module--ukIcon--1Fu8R","divide":"index-module--divide--1M5f8"};